var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpenOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.16867V12.8353M8 4.16867C7.22133 3.65134 6.164 3.33334 5 3.33334C3.836 3.33334 2.77867 3.65134 2 4.16867V12.8353C2.77867 12.318 3.836 12 5 12C6.164 12 7.22133 12.318 8 12.8353M8 4.16867C8.77867 3.65134 9.836 3.33334 11 3.33334C12.1647 3.33334 13.2213 3.65134 14 4.16867V12.8353C13.2213 12.318 12.1647 12 11 12C9.836 12 8.77867 12.318 8 12.8353",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpenOutline);
export default __webpack_public_path__ + "static/media/BookOpenOutline.5fd40809316b0632ad488e500b3231e0.svg";
export { ForwardRef as ReactComponent };